import {
  HubspotLeadGenerationForm,
  LeadGenFormProps,
} from "@ecologi/react-components/src/HubspotLeadGenerationForm";
import { pushLeadGenSuccess } from "../../lib";

type Props = {
  data: LeadGenFormProps;
};

export default function LeadGenerationForm(props: Props) {
  return (
    <HubspotLeadGenerationForm {...props.data} onSubmit={pushLeadGenSuccess} />
  );
}
